import React from 'react'
import { NavLink, useLocation } from 'react-router-dom';

const InventoryLayout = ({children}) => {
    const location = useLocation();
    const currentRoute = location.pathname;
    return (
        <div>
            <div className='h-[50px] w-full flex items-center'>
                <NavLink to="/admin/inventory/dashboard"  className={`font-medium text-sm nav-button px-3 py-3  ${currentRoute.includes('admin/inventory/dashboard') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>Inventory Dashboard</NavLink>

                <NavLink to="/admin/inventory/inventory-items"  className={`font-medium text-sm nav-button px-3 py-3  ${currentRoute.includes('admin/inventory/library') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>
                    Inventory Items
                </NavLink>

                <NavLink to="/admin/inventory/requests" className={`font-medium text-sm nav-button px-3 py-3  ${currentRoute.includes('admin/inventory/requests') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>Requests</NavLink>

                {/* <NavLink to="/admin/inventory/kitchen-stock" className={`font-medium text-sm nav-button px-3 py-3  ${currentRoute.includes('admin/inventory/kitchen-stock') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>
                    Kitchen Stock
                </NavLink>

                <NavLink to="/admin/inventory/sports-equipment" className={`font-medium text-sm nav-button px-3 py-3  ${currentRoute.includes('admin/inventory/sports-equipment') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>
                    Sports Equipment
                </NavLink> */}
                
            </div>
            <div className={`mt-10 min-h-screen`}>
                <main>{children}</main>
            </div>
        </div>
    )
}

export default InventoryLayout